import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AddUserFromKeycloakService } from '@core/services/add-user-from-keycloak.service';
import { KeycloakClient } from '../../services/keycloak/keycloak.client';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  protected router = inject(Router);
  private readonly keycloakClient = inject(KeycloakClient);
  private readonly addUserFromKeycloakService = inject(
    AddUserFromKeycloakService,
  );

  canActivate(): boolean {
    const authenticated = this.keycloakClient.isAuthenticated();
    if (!authenticated) {
      this.keycloakClient.login();
      return false;
    }
    // TODO add user to user table with keycloak hook
    this.addUserFromKeycloakService.addUserFromKeycloak();
    return true;
  }
}
